import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { AuthService } from '@incust-mobile/auth';
import {
  KeyboardBridgeService,
  LoadingService,
  StatusBarService
} from '@incust-mobile/core';
import { register } from 'swiper/element/bundle';
import { SplashScreen } from '@capacitor/splash-screen';
import { Platform } from '@ionic/angular';

register();

@Component({
  imports: [RouterModule, IonRouterOutlet, IonApp],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'card-app';
  private statusBarService = inject(StatusBarService);
  private keyboardBridgeService = inject(KeyboardBridgeService);
  private platform = inject(Platform);
  private loadingService = inject(LoadingService);

  constructor() {}

  async ngOnInit() {
    await this.loadingService.show();
    await this.platform.ready();
    await this.keyboardBridgeService.init();
    await SplashScreen.hide();
    await this.statusBarService.init({
      mainColor: '#FFFFFF',
      brandColor: '#33C6CC',
      brandOn: ['/auth/welcome', '/home/wallet']
    });
    await this.loadingService.hide();
  }
}
